import { Switch } from '@heroui/react';
import { FC, useState } from 'react';
import { TbPolygon } from 'react-icons/tb';
import { BiHide } from "react-icons/bi";

interface IPolygonLayerToggleProps {
	onPolygonLayerToggle: (event: any) => void;
}

const PolygonLayerToggle: FC<IPolygonLayerToggleProps> = ({ ...props }) => {
	const [polygonLayerEnabled, setPolygonLayerEnabled] = useState(false);
	const handlePolygonLayerToggle = (event: any) => {
		setPolygonLayerEnabled(event.target.checked);

		// dispatch the request detailed polygons
		props.onPolygonLayerToggle(event);
	};

	return (
		<div className="absolute z-10 opacity-85 ml-2" style={{ bottom: 71, right: 52 }}>
			<Switch
				classNames={{
					wrapper: 'rounded ',
					thumb: 'rounded',
				}}
				size="sm"
				onChange={handlePolygonLayerToggle}
				color="default"
				startContent={<BiHide />}
				endContent={<TbPolygon />}
				title={polygonLayerEnabled ? 'Hide Polygons' : 'Show Polygons'}
			/>
		</div>
	);
};

export default PolygonLayerToggle;
